type LogLevel = 'debug' | 'info' | 'warn' | 'error';

type LogContext = Record<string, unknown> | undefined;

function shouldEmit(level: LogLevel): boolean {
  if (level === 'debug') {
    return process.env.NODE_ENV !== 'production';
  }
  return true;
}

function format(scope: string, message: string, context?: LogContext): string {
  const payload = context ? ` ${JSON.stringify(context)}` : '';
  return `[${scope}] ${message}${payload}`;
}

export function log(level: LogLevel, scope: string, message: string, context?: LogContext): void {
  if (!shouldEmit(level)) return;

  const formatted = format(scope, message, context);
  if (level === 'warn') {
    console.warn(formatted);
    return;
  }
  if (level === 'error') {
    console.error(formatted);
    return;
  }
  console.log(formatted);
}
